module.exports = __webpack_public_path__ + "img/workout7.dd21a119.jpg";